import React, { Component } from 'react'
import { WithStylesProps } from 'react-jss'

import Icon from '../Icon'
import ChangesDisclaimer from '../ChangesDisclaimer'

import getLabels from '../../utils/getLabels'
import constants from '../../config/constants'
import PassengerToBeDeleted from '../../interfaces/client/PassengerToBeDeleted'
import FlightPassengerToBeDeleted from '../../interfaces/client/FlightPassengerToBeDeleted'
import styles from './FlightPassengersDeleteOverview.styles'

export interface FlightPassengersPropsInterface extends WithStylesProps<typeof styles> {
  items: PassengerToBeDeleted[]
  flightId: string
  deleteAllPaxFromSingleFlight: boolean
}

interface AutocompleteStateInterface {
  dateFormat: string
}

class FlightPassengersDeleteOverview extends Component<FlightPassengersPropsInterface, AutocompleteStateInterface> {
  state = {
    dateFormat: '',
  }

  componentDidMount() {
    this.setState({
      dateFormat: constants.frontEndDateFormat,
    })
  }

  renderFlight(flight: FlightPassengerToBeDeleted) {
    const { classes } = this.props

    return (
      <div className={classes.flight}>
        <div>{`${flight.origin}-${flight.destination}`}</div>
        <div>{flight.departureDate}</div>
        <div>{flight.departureTime}</div>
      </div>
    )
  }

  renderFlights(outboundFlight: FlightPassengerToBeDeleted, inboundFlight: FlightPassengerToBeDeleted) {
    const { classes } = this.props

    return (
      <div className={classes.flight}>
        <div>
          <div>{`${outboundFlight.origin}-${outboundFlight.destination}`}</div>
          <div
            className={classes.paddingTop}
          >{`${inboundFlight.origin}-${inboundFlight.destination}`}</div>
        </div>
        <div>
          <div>{outboundFlight.departureDate}</div>
          <div className={classes.paddingTop}>
            {inboundFlight.departureDate}
          </div>
        </div>
        <div>
          <div>{outboundFlight.departureTime}</div>
          <div className={classes.paddingTop}>
            {inboundFlight.departureTime}
          </div>
        </div>
      </div>
    )
  }

  getFlights(outboundFlight?: FlightPassengerToBeDeleted, inboundFlight?: FlightPassengerToBeDeleted) {
    if (this.props.deleteAllPaxFromSingleFlight) {
      if (outboundFlight !== undefined && this.props.flightId.startsWith(outboundFlight.origin)) {
        return this.renderFlight(outboundFlight)
      } else if (inboundFlight !== undefined && this.props.flightId.startsWith(inboundFlight.origin)) {
        return this.renderFlight(inboundFlight)
      }
    }

    if (outboundFlight !== undefined && inboundFlight !== undefined) {
      return this.renderFlights(outboundFlight, inboundFlight)
    }

    if (outboundFlight !== undefined) {
      return this.renderFlight(outboundFlight)
    }

    if (inboundFlight !== undefined) {
      return this.renderFlight(inboundFlight)
    }

    return null
  }

  renderContent() {
    const { classes, items } = this.props
    return (
      <React.Fragment>
        <div className={classes.row}>{getHeader(items.length)}</div>
        {items.map(item => {
          const { id, fullName, outbound, inbound, infantName } = item

          return (
            <div key={id} className={classes.row}>
              <div>{!fullName && infantName ? infantName : fullName}</div>
              <div>{this.getFlights(outbound, inbound)}</div>
              {infantName && fullName && <div>{infantName}</div>}
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  render() {
    const { classes, deleteAllPaxFromSingleFlight } = this.props

    return (
      <section>
        <header className={classes.header}>
          <Icon className={classes.icon} name="warningSign" />
          <h1 className={classes.title}>
            {getLabels('are_you_sure_you_want_to_delete_passengers')}
          </h1>
        </header>

        {deleteAllPaxFromSingleFlight ? (
          <ChangesDisclaimer
            disclaimer={getLabels(
              'warning_remove_all_passengers_from_pnr_body'
            )}
          />
        ) : (
          <ChangesDisclaimer
            disclaimer={getLabels('warning_this_cannot_be_undone')}
          />
        )}

        <article className={classes.content}>{this.renderContent()}</article>
      </section>
    )
  }
}

const getHeader = (selectedSize: number) => (
  <React.Fragment>
    <h4>
      {getLabels('passenger_selected').replace('{0}', `(${selectedSize})`)}
    </h4>
    <h4>{getLabels('flights')}</h4>
  </React.Fragment>
)

export default FlightPassengersDeleteOverview
